import { COLOR_NIGHT_900_10P, COLOR_NIGHT_900_16P, COLOR_NIGHT_900_8P } from '../definitions/color';

export type Elevation = keyof typeof ELEVATION;

export const ELEVATION = {
    0: 'none',
    25: `0px 4px 6px -1px ${COLOR_NIGHT_900_8P}, 0px -1px 4px -2px ${COLOR_NIGHT_900_16P}`,
    50: `0px 8px 24px -4px ${COLOR_NIGHT_900_10P}, 0px 6px 12px -6px ${COLOR_NIGHT_900_10P}`,
    100: `0px 18px 88px -4px ${COLOR_NIGHT_900_10P}, 0px 12px 28px -6px ${COLOR_NIGHT_900_10P}`,
} as const;
